import { render, staticRenderFns } from "./WeeklyForm.vue?vue&type=template&id=2d28126c&"
import script from "./WeeklyForm.vue?vue&type=script&lang=js&"
export * from "./WeeklyForm.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyForm.vue?vue&type=style&index=0&id=2d28126c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QForm,QInput,QBtn,QSpinner,QDialog,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QForm,QInput,QBtn,QSpinner,QDialog,QInnerLoading,QSpinnerTail})
